import React from 'react';
import '../less/policy.less';
import FAQStorybook from '@abank/abank-faq';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import hero_img from '../img/hero_img.png';
import Tariffs from '../../../auxiliary-components/shared/TariffsBlock';
import additionalCards from '../enums/additional_cards_data.json';
import insurerInfoDataConfig from '../enums/insurer_info_data.json';
import intermediaryAbankTariffsData from '../enums/intermediary_abank_tariffs_data.json';
import intermediaryPolisTariffsData from '../enums/intermediary_polis_tariffs_data.json';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import { insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoEiaLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink, insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoTaslifeLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoUniversalnaLink,insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoVusoLink, insuranceDocumentsArxCompanyLink, insurancePolicyDocumentsArxProductLink, insuranceDocumentsArsenalCompanyLink, insurancePolicyDocumentsArsenalProductLink, insuranceDocumentsVusoCompanyLink, insurancePolicyDocumentsVusoProductLink, insuranceDocumentsEuroinsCompanyLink, insurancePolicyDocumentsEuroinsProductLink, insuranceDocumentsEiaCompanyLink, insurancePolicyDocumentsEiaProductLink, insuranceDocumentsIngoCompanyLink, insurancePolicyDocumentsIngoProductLink, insuranceDocumentsInterPolicyCompanyLink, insurancePolicyDocumentsInterPolicyProductLink, insuranceDocumentsOrantaCompanyLink, insurancePolicyDocumentsOrantaProductLink, insuranceDocumentsPzuCompanyLink, insurancePolicyDocumentsPzuProductLink, insuranceDocumentsTasCompanyLink, insurancePolicyDocumentsTasProductLink, insuranceDocumentsUniversalnaCompanyLink, insurancePolicyDocumentsUniversalnaProductLink, insuranceDocumentsUniqaCompanyLink, insurancePolicyDocumentsUniqaProductLink, insuranceDocumentsUsgCompanyLink, insurancePolicyDocumentsUsgProductLink, insuranceDocumentsUticoCompanyLink, insurancePolicyDocumentsUticoProductLink, insuranceDocumentsGuardianCompanyLink, insurancePolicyDocumentsGuardianProductLink, insuranceIntermediaryInfoGuardianLink } from '../../../services/urls/urls';
import { Preloader } from 'MWComponents';
import intermediaryAbankInfoDataConfig from '../enums/intermediary_abank_info_data.json';
import intermediaryPolisInfoDataConfig from '../enums/intermediary_polis_info_data.json';
import InsuranceIntermediaryInfo from '../../../auxiliary-components/shared/InsuranceIntermediaryInfo';
import AdditionalProduct from '../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import QuestionsFullAdmin from '../../../auxiliary-components/shared/QuestionsFullAdmin';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import how_to_block_items from '../enums/how_to_block_items.json';
import { mapInsuranceDetailedInfoToTariffs } from './../../../helpers/utils/mapInsuranceDetailedInfoToTariffs';
import HowToBlockNew from '../../../auxiliary-components/shared/HowToBlockNew';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';
import { canUseDOM } from '../../../helpers/canUseDOM';
import AdvantagesAdmin from './../../../auxiliary-components/shared/AdvantagesBlockAdmin';

export default function template() {
  const tabs = [{tab: 'insurer-info', title: 'SERVICES_POLICY_NEW_TABS_TITLE_01'},
        {tab: 'partners', title: 'SERVICES_POLICY_NEW_TABS_TITLE_02'},
        {tab: 'insurance-info', title: 'SERVICES_POLICY_NEW_TABS_TITLE_03'},
        {tab: 'intermediary-info', title: 'SERVICES_POLICY_NEW_TABS_TITLE_04'}];

  const tabsShortIntermediaryInsuranceInfo= [{tab: 'abank-short', title: 'SERVICES_POLICY_NEW_TABS_INTERMEDIARY_INFO_TITLE_01'},
                {tab: 'polis-short', title: 'SERVICES_POLICY_NEW_TABS_INTERMEDIARY_INFO_TITLE_02'}];

  const tabsFullIntermediaryInsuranceInfo = [{tab: 'abank-full', title: 'SERVICES_POLICY_NEW_TABS_INTERMEDIARY_INFO_TITLE_01'},
                {tab: 'polis-full', title: 'SERVICES_POLICY_NEW_TABS_INTERMEDIARY_INFO_TITLE_02'}];

  const imagesMap = {
    how_to_block_img_1,
    how_to_block_img_2,
    how_to_block_img_3
  };

  const linksMap = { insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoVusoLink,insuranceIntermediaryInfoUniversalnaLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoEiaLink,insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink, insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoTaslifeLink, insuranceDocumentsArxCompanyLink, insurancePolicyDocumentsArxProductLink, insuranceDocumentsArsenalCompanyLink, insurancePolicyDocumentsArsenalProductLink, insuranceDocumentsVusoCompanyLink, insurancePolicyDocumentsVusoProductLink, insuranceDocumentsEuroinsCompanyLink, insurancePolicyDocumentsEuroinsProductLink, insuranceDocumentsEiaCompanyLink, insurancePolicyDocumentsEiaProductLink, insuranceDocumentsIngoCompanyLink, insurancePolicyDocumentsIngoProductLink, insuranceDocumentsInterPolicyCompanyLink, insurancePolicyDocumentsInterPolicyProductLink, insuranceDocumentsOrantaCompanyLink, insurancePolicyDocumentsOrantaProductLink, insuranceDocumentsPzuCompanyLink, insurancePolicyDocumentsPzuProductLink, insuranceDocumentsTasCompanyLink, insurancePolicyDocumentsTasProductLink, insuranceDocumentsUniversalnaCompanyLink, insurancePolicyDocumentsUniversalnaProductLink, insuranceDocumentsUniqaCompanyLink, insurancePolicyDocumentsUniqaProductLink, insuranceDocumentsUsgCompanyLink, insurancePolicyDocumentsUsgProductLink, insuranceDocumentsUticoCompanyLink, insurancePolicyDocumentsUticoProductLink, insuranceDocumentsGuardianCompanyLink, insurancePolicyDocumentsGuardianProductLink, insuranceIntermediaryInfoGuardianLink };

  const enrichCompaniesLinks = (data, linksMap) =>
    data.map(item => {
      if (item.type === 'companies' && Array.isArray(item.companies)) {
        return {
          ...item,
          companies: item.companies.map(company => ({
            ...company,
            link: linksMap[company.link]
          }))
        };
      }

      return item;
  });

  const intermediaryAbankInfoData = enrichCompaniesLinks(
    intermediaryAbankInfoDataConfig,
    linksMap
  );

  const intermediaryPolisInfoData = enrichCompaniesLinks(
    intermediaryPolisInfoDataConfig,
    linksMap
  );

  const insurerInfoData = insurerInfoDataConfig.map(item => ({
    ...item,
    values: item.values.map(val => {
      if (val.type === 'button') {
        return {
          ...val,
          btnLink: linksMap[val.btnLink],
        };
      }

      return val;
    }),
  }));

  const howToBlockItems = how_to_block_items.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const hero_data = {
    title: "SERVICES_POLICY_NEW_HERO_TITLE",
    text: "SERVICES_POLICY_NEW_HERO_TEXT"
  }

  const advantagesWidget = this.widgetsHelper.getWidget.call(this, 'green_text_block');

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  const partnersWidget = this.widgetsHelper.getWidget.call(this, 'partners');
  
  const detailedInfoWidget = this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoWidget', 'questions');

  const detailedInfoTariffsItems = mapInsuranceDetailedInfoToTariffs(detailedInfoWidget);

  const shortIntermediaryInsuranceInfoData = [
    intermediaryAbankTariffsData,
    intermediaryPolisTariffsData
  ];

  const fullIntermediaryInsuranceInfoData = [
    intermediaryAbankInfoData,
    intermediaryPolisInfoData
  ];

  return (
    <div className="services-policy-new">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className={`content${(this.state.faqTab || this.state.detailedInsuranceInfoTab || this.state.intermediaryInsuranceInfoTab) ? ' hidden' : ''}`}>
          <div className="general-info">
            <div className="container">
              <h2 className="general-info__title">{this.l10n('SERVICES_POLICY_NEW_GENERAL_INFO_TITLE')}</h2>
              <div className="general-info__text">
                <p>{this.l10n('SERVICES_POLICY_NEW_GENERAL_INFO_TEXT_01')}</p>
                <p>{this.l10n('SERVICES_POLICY_NEW_GENERAL_INFO_TEXT_02')}</p>
              </div>
            </div>
          </div>
          <AdvantagesAdmin
            data={advantagesWidget}
            loader={this.state.loader}
          />
          <HowToBlockNew
            title={'SERVICES_POLICY_NEW_HOW_TO_TITLE'}
            items={howToBlockItems}
          />
          <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
            <Tariffs
              items={insurerInfoData}
              title={'SERVICES_POLICY_TARIFFS_INSURER_INFO_TITLE'}
              titleTag={"div"}
            />
            {this.state.loader ? (canUseDOM ? <Preloader/> : null) : (partnersWidget && partnersWidget.data && partnersWidget.data.length > 0 ? (
              <div className="partners">
                <div className="container">
                  <div className="partners__body">
                  {partnersWidget.data.sort((a, b) => a.order - b.order).map((item, index) => (
                    <div className="partners__item" key={index}>
                      <img className="partners__image" src={item.img_desktop} alt="partners image"/>
                    </div>
                  ))}
                  </div>
                </div>
              </div>
            ) : null)}
            {this.state.detailedInfoWidget_loading ? (canUseDOM ? <Preloader/> : null) : (detailedInfoTariffsItems && detailedInfoTariffsItems.length > 0 ? (
              <Tariffs
                items={detailedInfoTariffsItems}
                alignItems="start"
                onBtnClick={this.toggleDetailedInsuranceInfoTab}
                btnText={'SERVICES_POLICY_NEW_TARIFFS_INSURANCE_INFO_BTN'}
                insuranceInfo
              />
            ) : null)}
            <Tabs tabs={tabsShortIntermediaryInsuranceInfo} toggle={this.toggleShortIntermediaryInsuranceInfoTab} tab={this.state.tabShortIntermediaryInsuranceInfo} title={'SERVICES_POLICY_NEW_TARIFFS_INTERMEDIARY_INFO_TITLE'}>
              {shortIntermediaryInsuranceInfoData.map((item, index) => (
                <Tariffs
                  key={index}
                  items={item}
                  alignItems="start"
                  onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
                  btnText={'SERVICES_POLICY_NEW_TARIFFS_INTERMEDIARY_INFO_BTN'}
                />
              ))}
            </Tabs>
          </Tabs>
          <AdditionalProduct
            items={additionalCards}
            title={'SERVICES_POLICY_NEW_ADDITIONAL_PRODUCT_TITLE'}
          />
          <QuestionsAdminNew
            widget={questionsWidget}
            toggleFaqTab={this.toggleFaqTab}
            title={'SERVICES_POLICY_NEW_QUESTIONS_TITLE'}
            loader={this.state.loader}
          />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('SERVICES_POLICY_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('SERVICES_POLICY_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
      <div className={`content${!this.state.detailedInsuranceInfoTab ? ' hidden' : ''}`}>
        <QuestionsFullAdmin
          widget={detailedInfoWidget}
          title={'SERVICES_POLICY_NEW_DETAILED_INFO_TITLE'}
          toggleFaqTab={this.toggleDetailedInsuranceInfoTab}
        />
      </div>
      <div className={`content${!this.state.intermediaryInsuranceInfoTab ? ' hidden' : ''}`}>
        <div>
          <div className="intermediary-insurance-info">
            <div className="container">
              <div className="intermediary-insurance-info__top">
                <h2 className="intermediary-insurance-info__title">{this.l10n('SERVICES_POLICY_NEW_INTERMEDIARY_INFO_TITLE')}</h2>
                <button className="intermediary-insurance-info__btn" onClick={this.toggleIntermediaryInsuranceInfoTab}>{this.l10n('SERVICES_POLICY_NEW_INTERMEDIARY_INFO_BTN')}</button>
              </div>
            </div>
          </div>
          <Tabs tabs={tabsFullIntermediaryInsuranceInfo} toggle={this.toggleFullIntermediaryInsuranceInfoTab} tab={this.state.tabFullIntermediaryInsuranceInfo}>
            {fullIntermediaryInsuranceInfoData.map((item, index) => (
              <InsuranceIntermediaryInfo
                key={index}
                items={item}
              />
            ))}
          </Tabs>
        </div>  
      </div>
    </div>
  )
}
